import * as React from "react";
import { forwardRef } from "react";
const SvgChatMessageCorner = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Corner Lo", fillRule: "evenodd", clipRule: "evenodd", d: "M12 0L12 12L0 12L12 0Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgChatMessageCorner);
export { ForwardRef as ReactComponent };
